<template>
    <div class="rr-shopping-cart__coupon uk-card uk-card-default uk-card-body uk-card-small">
        <p class="uk-text-bold uk-margin-small-bottom">
            {{ $t('rubinred.ecommerce.orders.common.coupon_title') }}
        </p>
        <div>
            <div v-for="coupon in coupons" class="uk-label uk-margin-small-bottom" :title="coupon.promo_name" uk-tooltip>
                <span class="uk-margin-small-right">{{coupon.code}}</span>
                <a class="uk-light" @click="removeCoupon(coupon.code)"><i class="fal fa-times"></i></a>
            </div>
        </div>
        <div class="uk-grid-collapse" uk-grid>
            <div class="uk-width-3-5@m">
                <form-input ref="input"></form-input>
            </div>
            <div class="uk-width-2-5@m">
                <button class="uk-button uk-button-primary uk-width-1-1" type="button" @click="applyCoupon">
                    {{ $t('rubinred.ecommerce.orders.action.coupon_apply') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    props: {
      coupons: {
        type: Array,
        required: true,
      },
    },
    methods: {
      removeCoupon(code) {
        this.$store.dispatch('cart/removeCoupon', code);
      },
      applyCoupon() {
        const code = this.$refs.input.getValue();
        if(code) {
          this.$store.dispatch('cart/applyCoupon', code).then(({data}) => {
            if(data.success) {
              this.$refs.input.setValue('');
            }
          });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/cart/RubinredCartCoupons.vue